export const siteConfig = {
  brand: "吃瓜网上",
  slogan: "每天都有新鲜瓜，吃瓜永不掉队",
  desc: "精选热门事件、新鲜事与话题推荐，帮你轻松冲浪、不错过精彩。",
};

export interface TrendingItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "down" | "flat";
}

export interface NewsItem {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  time: string;
  reads: string;
  image: string;
  hot?: boolean;
}

export interface GuideTip {
  icon: string;
  title: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
  initial: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories = [
  { key: "all", name: "全部" },
  { key: "娱乐八卦", name: "娱乐八卦" },
  { key: "影视综艺", name: "影视综艺" },
  { key: "科技前沿", name: "科技前沿" },
  { key: "社会百态", name: "社会百态" },
  { key: "体坛风云", name: "体坛风云" },
  { key: "生活趣闻", name: "生活趣闻" },
];

export const trending: TrendingItem[] = [
  { rank: 1, title: "国庆档电影票房刷新纪录，这几部你看了没？", tag: "影视", heat: "1280.6万", trend: "up" },
  { rank: 2, title: "新晋国漫《星海归途》口碑爆发，网友直呼年度惊喜", tag: "动漫", heat: "986.3万", trend: "up" },
  { rank: 3, title: "AI 手机赛道白热化，端侧大模型谁更聪明？", tag: "科技", heat: "742.9万", trend: "up" },
  { rank: 4, title: "夜市经济回温，城市烟火气里的新吃法盘点", tag: "生活", heat: "501.2万", trend: "flat" },
  { rank: 5, title: "羽毛球全锦赛爆冷，00后小将一战成名", tag: "体坛", heat: "376.5万", trend: "up" },
  { rank: 6, title: "复古街机厅重开，属于一代人的青春回来了", tag: "趣闻", heat: "268.7万", trend: "down" },
];

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: "金秋综艺《城市漫游记》开播，镜头下的烟火气太治愈了",
    excerpt: "一档让嘉宾放慢脚步、走进陌生街巷的慢综艺，被不少观众形容为「精神按摩」。本期走进老城早市，慢镜头下的早餐铺与邻里问候格外动人。",
    category: "影视综艺",
    time: "今天 09:24",
    reads: "12.6万",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Cozy%20warm%20street%20food%20market%20morning%20scene%20with%20steam%20rising%20from%20breakfast%20stalls%20and%20soft%20golden%20sunlight%2C%20cinematic%20documentary%20style%2C%20warm%20cream%20and%20orange%20color%20palette%2C%20gentle%20editorial%20photography&width=900&height=640&seq=news-variety-01&orientation=landscape",
  },
  {
    id: 2,
    title: "科幻动画《深海回响》上线，手绘质感引爆弹幕区",
    excerpt: "耗费数年手绘打磨的动画长片，用光与影讲述海洋与归乡的故事。上线首日讨论量飙升，网友评价「每一帧都能当壁纸」。",
    category: "影视综艺",
    time: "今天 08:52",
    reads: "9.8万",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Hand%20drawn%20style%20fantasy%20ocean%20deep%20sea%20scene%20with%20glowing%20light%20rays%20and%20whale%20silhouette%2C%20teal%20and%20amber%20cinematic%20lighting%2C%20artistic%20illustration%2C%20rich%20texture%2C%20warm%20undertones&width=900&height=640&seq=news-anime-02&orientation=landscape",
  },
  {
    id: 3,
    title: "端侧大模型上新，手机 AI 能自己修图了？实测来了",
    excerpt: "头部厂商陆续把大模型搬进手机，离线也能对话、修图、做摘要。我们挑了几款热门机型实测，看看「不用联网的 AI」究竟多能打。",
    category: "科技前沿",
    time: "今天 08:10",
    reads: "7.2万",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20soft%20glowing%20neural%20network%20interface%20floating%20above%2C%20minimal%20studio%20shot%2C%20cream%20and%20soft%20coral%20gradient%20background%2C%20clean%20product%20photography%20with%20soft%20shadows&width=900&height=640&seq=news-tech-03&orientation=landscape",
  },
  {
    id: 4,
    title: "「反向旅游」火了：年轻人为什么偏爱冷门小城？",
    excerpt: "当热门景区人满为患，越来越多年轻人选择扎进小众县城，用更低成本换更高体验。这份「反向旅游」图鉴或许能给你新灵感。",
    category: "生活趣闻",
    time: "昨天 21:40",
    reads: "5.6万",
    image: "https://readdy.ai/api/search-image?query=Serene%20small%20town%20backpacker%20street%20in%20morning%20with%20potted%20plants%20and%20old%20stone%20houses%2C%20soft%20warm%20light%2C%20peaceful%20editorial%20travel%20photography%2C%20mint%20and%20cream%20palette%2C%20no%20crowds&width=900&height=640&seq=news-travel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "草根乐队爆红网络，一首歌让整座城同唱",
    excerpt: "几位在街头演出多年的乐手，因为一段现场视频被疯狂转发。他们不赶潮流，只写自己身边的平凡故事，却戳中了无数人的心。",
    category: "娱乐八卦",
    time: "昨天 19:15",
    reads: "11.3万",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Indie%20band%20performing%20live%20on%20warmly%20lit%20street%20stage%20at%20dusk%2C%20guitar%20and%20microphone%2C%20crowd%20silhouette%2C%20golden%20amber%20and%20coral%20tones%2C%20concert%20photography%2C%20energetic%20atmosphere&width=900&height=640&seq=news-band-05&orientation=landscape",
  },
  {
    id: 6,
    title: "博物馆夜场再扩容，白天上班的人有福了",
    excerpt: "越来越多的博物馆开放夜场与「周五晚专场」，看展也能变成下班后的轻量消遣。这份全国夜展攻略，帮你在夜里慢慢逛。",
    category: "社会百态",
    time: "昨天 17:08",
    reads: "4.1万",
    image: "https://readdy.ai/api/search-image?query=Elegant%20museum%20exhibition%20hall%20at%20night%20with%20soft%20spotlight%20on%20art%20installations%2C%20warm%20cream%20and%20amber%20interior%20lighting%2C%20peaceful%20cultural%20photography%2C%20minimal%20composition&width=900&height=640&seq=news-museum-06&orientation=landscape",
  },
  {
    id: 7,
    title: "羽毛球全锦赛新生代闪耀，00后小将三局逆转",
    excerpt: "一场跌宕起伏的三局大战，把一位此前名不见经传的 00 后送进决赛。他在网前的手感与逆风局的冷静，成了这个周末最热的谈资。",
    category: "体坛风云",
    time: "昨天 15:32",
    reads: "6.9万",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20badminton%20player%20jumping%20to%20smash%20shuttlecock%20in%20indoor%20arena%2C%20bright%20court%20lighting%2C%20teal%20and%20cream%20motion%20photography%2C%20energetic%20and%20crisp%20focus&width=900&height=640&seq=news-sport-07&orientation=landscape",
  },
  {
    id: 8,
    title: "复古街机厅重开，投币声里都是青春的回响",
    excerpt: "随着怀旧风潮兴起，一座座老式街机厅在城市角落重新亮灯。拳皇、街霸、投篮机……那些投币声，成了不少人找回青春的入口。",
    category: "生活趣闻",
    time: "昨天 13:47",
    reads: "3.8万",
    image: "https://readdy.ai/api/search-image?query=Nostalgic%20arcade%20room%20with%20colorful%20retro%20game%20cabinets%20glowing%20screens%20at%20dusk%2C%20warm%20neon%20amber%20and%20coral%20light%2C%20vintage%20atmosphere%2C%20evocative%20editorial%20photography&width=900&height=640&seq=news-arcade-08&orientation=landscape",
  },
];

export const guideTips: GuideTip[] = [
  { icon: "ri-flashlight-fill", title: "善用「今日新鲜」", desc: "每天清晨更新的新鲜快讯，是快速感知当天热度的第一站，先扫一眼再深挖。", },
  { icon: "ri-fire-fill", title: "盯紧「热门瓜榜」", desc: "实时热度榜帮你抓住大家都在讨论的话题，避免错过关键剧情与转折。", },
  { icon: "ri-focus-3-fill", title: "订阅感兴趣的标签", desc: "把娱乐、科技、体坛等标签存进收藏，系统为你持续推荐同类新鲜事。", },
  { icon: "ri-time-fill", title: "控制刷瓜节奏", desc: "给自己设定轻松的碎片时间，按「先热点、后收藏、再深读」的顺序高效吃瓜。", },
  { icon: "ri-chat-check-fill", title: "多方对照再讨论", desc: "对争议话题多看几个视角、核对来源，做到理性吃瓜，不盲从不传谣。", },
  { icon: "ri-bookmark-line", title: "别急着滑走，先存后读", desc: "遇到长内容随手收藏，攒到周末慢慢看，让每一次冲浪都更有收获。", },
];

export const testimonials: Testimonial[] = [
  { name: "阿杰", role: "通勤刷瓜党", initial: "杰", quote: "每天早上在地铁上刷一遍今日新鲜，感觉一下就和世界接上了，内容更新很及时。", },
  { name: "小梨", role: "综艺追更用户", initial: "梨", quote: "分类很清爽，点进「影视综艺」就是我追的那些，弹幕热梗也能第一时间看懂。", },
  { name: "老周", role: "科技爱好者", initial: "周", quote: "冲浪指南里的「多方对照」提醒很实用，现在吃科技瓜我会先看评论区大家的科普。", },
  { name: "南南", role: "内容创作者", initial: "南", quote: "灵感枯竭时就来翻瓜榜找选题，话题热度和阅读都让我心里有数，效率高了不少。", },
];

export const faqs: FaqItem[] = [
  { q: "「吃瓜网上」是什么？", a: "吃瓜网上是一个聚合热门事件、新鲜事与话题推荐的内容浏览与发现站。你可以在这里快速浏览今日新鲜快讯、查看实时热门瓜榜，并通过分类和标签找到自己感兴趣的内容，随时随地享受轻松吃瓜的体验。" },
  { q: "网站多久更新一次内容？", a: "「今日新鲜」栏目每天清晨集中更新，白天也会根据热门事件滚动补充；「热门瓜榜」则基于讨论热度持续刷新，尽量让你不错过任何正在升温的话题。" },
  { q: "需要注册登录才能看吗？", a: "不需要。绝大多数内容和榜单都可以直接在线浏览，无需注册。后续如果加入收藏、订阅标签等个性化功能，才会涉及可选账号体系。" },
  { q: "如何快速找到感兴趣的话题？", a: "你可以使用首屏的搜索框，或在「分类浏览」中按娱乐八卦、影视综艺、科技前沿、社会百态、体坛风云、生活趣闻等分类切换，浏览推荐也会结合你常看的标签给出参考。" },
  { q: "看到的内容来源可靠吗？", a: "我们会尽量汇总并标注多方来源与不同视角，供你对照判断。对于争议性话题，也建议你在评论区或相关信源进一步核实，做到理性吃瓜、不信谣不传谣。" },
  { q: "可以反馈选题或提出建议吗？", a: "当然可以。欢迎通过页面底部页脚的联系入口给我们留言，告诉我们你想看的话题或改进建议，我们会认真参考并持续优化内容。" },
];

export const brandStats = [
  { value: "5000+", label: "每日精选话题" },
  { value: "128 万", label: "月活吃瓜用户" },
  { value: "6 大", label: "内容分类栏目" },
  { value: "24h", label: "热度实时刷新" },
];